import styled from 'styled-components';

export const Input = styled.input<{
  error?: boolean;
  phColor?: string;
  minWidth?: string;
}>`
  border-radius: 10px;
  background-color: var(--color-surface-1);
  border: ${(props: { error?: boolean }): string =>
    props.error
      ? '1px solid var(--color-danger)'
      : '1px solid var(--color-separator)'};
  padding: 10px 5px;
  color: var(--color-control-text);
  width: 100%;
  min-width: ${(props: { minWidth?: string }): string =>
    props.minWidth ? props.minWidth : '150px'};
  ::placeholder {
    color: ${(props: { phColor?: string }): string =>
      props.phColor ? `${props.phColor}` : null};
  }
  &:focus {
    outline: none;
  }
`;
